export function checkOwnerOrAdmin(params: { ownerId?: string | null; currentUid?: string | null; isAdmin?: boolean; context?: string }): boolean {
  const { ownerId, currentUid, isAdmin, context } = params;
  const ok = !!isAdmin || (!!ownerId && ownerId === currentUid);
  if (!ok) {
    console.warn('[authz] not owner or admin', { context, ownerId, currentUid });
  }
  return ok;
}

export function assertOwnerOrAdmin(...args: any[]): void {
  const ok = checkOwnerOrAdmin(Array.isArray(args) ? args[0] : (args as any));
  if (!ok) console.warn('[authz] assertOwnerOrAdmin deprecated path used; returning without throwing');
}

